import Cookies from 'js-cookie';

const getCookie = name => { 
    let cookie = Cookies.get(name);    
    if('access_token' === name && (cookie === undefined || cookie === null || cookie.trim() === '')) {      
        return process.env.REACT_APP_TOKEN;
    }
    return cookie;
};

export default getCookie;
